export default __webpack_public_path__ + "static/media/image11.e1b03931.jpg";